import { Injectable, OnDestroy } from '@angular/core';
import { IItems, INavigator } from '@app/models/interfaces/ISearchFilters';
import { SelectItem } from '@app/modules/tf-filters';
import { StoreService } from "@app/services/store.service";
import { Subscription } from "rxjs";
import { DecimalPipe } from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class FiltersService implements OnDestroy {
    selectedOptionsSubscription: Subscription;
    selectedOptions: SelectItem[][] = [];
    geneFilterKeyword: string[] = [];
    overlayVisible: boolean[] = [];

    filteredOutNavigators = {
        "CNV": {
            "assaySets": {
                "validated": true
            },
        }
    }

    constructor(
        private storeService: StoreService,
        private decimalPipe: DecimalPipe,
    ) {
    }

    ngOnDestroy() {
        this.selectedOptionsSubscription.unsubscribe();
    }

    setItems(filters: any, type: string, hasFilterParams: boolean, filterName: string[]): IItems[] {
        if (this.selectedOptions.length === 0) this.storeService.setDefaultState(filters.length);
        const items = [];
        this.getSelectedOptions();
        filters.forEach((filter, index) => {
            const navigators = this.getNavigators(filter, index);
            if(hasFilterParams) this.preSelectorFilters(navigators, filter, index, filterName);

            items.push({
                name: filter.name,
                queryName: filter.queryName,
                disabled: filter.disabled,
                allowOnlyOne: this.isAllowOnlyOne(filter),
                productSubType: filter.productSubType,
                navigators: navigators,
                selectedOptions: this.selectedOptions[index],
                overlayVisible: this.overlayVisible && this.overlayVisible[index],
                searchInputValue: this.geneFilterKeyword && this.geneFilterKeyword[index],
                isServerSideSearch: this.getServerSideSearch(filter.name),
                isLoading: false,
                hasSearch: this.hasSearchSection(filter.productSubType, filter.name, type)
            })
        });

        return items;
    }

    isAllowOnlyOne(filter) {
        // ToDo: improve this approach to make it more dynamic
        return filter.productSubType === "CNV" && filter.queryName === "Attributes";
    }

    preSelectorFilters(navigators: INavigator[], filter: IItems, filterIdx: number, filterNames: string[]) {
        let selectedOptions = [];

        navigators?.forEach(navigator => {
            if(navigator['isChecked']) {
                selectedOptions = [...selectedOptions, navigator];
                this.storeService.setSelectedFilters(navigator);
            }
        })

        for(const filterName of filterNames) {
            if(filter.queryName === filterName) this.storeService.setSelectedOptions(filterIdx, selectedOptions);
        }
    }

    getSelectedOptions() {
        this.selectedOptionsSubscription = this.storeService.tempFilters$.subscribe((state) => {
            this.selectedOptions = state.selectedOptions;
            this.geneFilterKeyword = state.geneFilterKeyword;
            this.overlayVisible = state.overlayVisible;
        });
    }

    getNavigators(filter, index) {
        const navigators = [];

        filter.navigators?.forEach((navigator: INavigator) => {

            const productSubType = filter.productSubType;
            const queryName = filter.queryName;
            const navigatorName = navigator.name.toLowerCase();

            if(!(this.filteredOutNavigators[productSubType]
                && this.filteredOutNavigators[productSubType][queryName]
                && this.filteredOutNavigators[productSubType][queryName][navigatorName])) {
                navigators.push({
                    app: navigator.name,
                    value: {
                        id: navigator.navigatorName,
                        name: navigator.queryValue,
                        code: navigator.name,
                        count: this.decimalPipe.transform(navigator.count)
                    },
                    serverNavigator: navigator,
                    code: navigator.solrFacetName,
                    isChecked: navigator.checked,
                    order: index
                });
            }
        });

        return navigators;
    }

    getServerSideSearch(type: string): boolean {
        return type === "Genes";
    }

    hasSearchSection(productType: string, filterName: string, type: string) {
        if (productType === 'GE') {
            const GEassayFilters = ['Species', 'Genes', 'Remove cross-reactivity'];
            const GEarrayFilters = ['Instruments'];
            return type === 'assay' ? GEassayFilters.includes(filterName) : GEarrayFilters.includes(filterName);
        } else if (productType === 'SNP') {
            const SNPassayFilters = ['Genes'];
            return SNPassayFilters.includes(filterName);
        } else if (productType === 'CNV') {
            const CNVassayFilters = ['Genes'];
            return CNVassayFilters.includes(filterName);
        } else if (productType === 'ADVANCED_MIRNA') {
            const miRNAassayFilters = ['Species (compatible)'];
            return miRNAassayFilters.includes(filterName);
        } else if (productType === 'CLASSIC_MIRNA') {
            const miRNAClassicassayFilters = ['Species'];
            return miRNAClassicassayFilters.includes(filterName);
        } else {
            return false;
        }


    }
}
